import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FlexItem } from '../../styled/layout.styled';
import Input from './Input';
import Button from './Button';
import BaseModal from '../../../components/BaseModal/BaseModal';
import apiClient from '../../../helpers/apiClient';
import toastNotify from '../../utils/toastNotify';

const StyledForm = styled.form`
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin-top: 32px;
  flex-wrap: wrap;
`;

const CreateCampaignModal = ({
  open,
  onClose,
  handleSubmit,
  errors,
  register,
  label,
  name,
  isValid,
  reset,
  onCampaignCreated,
}) => {
  const [defaultCampaignCode, setDefaultCampaignCode] = useState('');
  const onSubmit = value => {
    apiClient()
      .post('/api/v1/affiliate/campaign', value)
      .then(() => {
        onCampaignCreated();
        toastNotify('Campaign Created', 3000);
      })
      .catch(() => {
        toastNotify('duplicate campaign name', 3000, true);
      });
    reset();
    onClose();
  };
  useEffect(() => {
    if (open) {
      apiClient()
        .get('/api/v1/affiliate/campaign/code/recommend')
        .then(res => {
          const { campaign_code: campaignCode } = res || '';
          setDefaultCampaignCode(() => campaignCode);
        })
        .catch(e => console.log(e));
    }
  }, [open]);
  return (
    <>
      <BaseModal title="Create Campaign" open={open} onClick={onClose}>
        <StyledForm onSubmit={handleSubmit(onSubmit)}>
          <FlexItem width="48%" mobileWidth="100%">
            <Input
              name={name.first}
              label={label.first}
              inputType="text"
              error={errors}
              backGroundColor="#12033d"
              ref={register}
              modalInputActive
            />
          </FlexItem>
          <FlexItem width="48%" mobileWidth="100%" mobileMargin="26px 0 0 0">
            <Input
              name={name.second}
              label={label.second}
              inputType="text"
              error={errors}
              backGroundColor="#12033d"
              ref={register}
              modalInputActive
              value={defaultCampaignCode}
            />
          </FlexItem>
          <FlexItem width="100%" margin="24px 0 0 0" mobileMargin="42px 0 0 0">
            <Button disabled={!isValid} type="submit">
              Create Campaign
            </Button>
          </FlexItem>
        </StyledForm>
      </BaseModal>
    </>
  );
};

CreateCampaignModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  register: PropTypes.func.isRequired,
  reset: PropTypes.func.isRequired,
  errors: PropTypes.objectOf(PropTypes.any).isRequired,
  label: PropTypes.objectOf(PropTypes.any).isRequired,
  name: PropTypes.objectOf(PropTypes.any).isRequired,
  isValid: PropTypes.bool.isRequired,
  onCampaignCreated: PropTypes.func.isRequired,
};
export default CreateCampaignModal;
